export enum SlhNavigationItemTypeEnum {
  HOME = "home",
  USER = "user",
  SETTING = "setting",
  SIGNIN = "signIn",
  SIGNOUT = "signOut",
  ORGANIZATION = "organization",
  APP = "application",
  LANGUAGE = "language",
  CART = "cart",
}
